import { Err, Ok, Result } from 'ts-res';
import { KameleoonError } from 'src/kameleoonError';
import { Utilities } from 'src/utilities/utilities';
import { KameleoonData } from 'src/kameleoonData/types';
import { EvaluationDataType, VersionMatchType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';

export class ApplicationVersion implements ICondition {
  private conditionValue?: string | null;
  private versionMatchType?: VersionMatchType | null;

  constructor({ version, versionMatchType }: ConditionDataType) {
    this.conditionValue = version;
    this.versionMatchType = versionMatchType;
  }

  public evaluate({
    targetingData,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const version = targetingData?.[KameleoonData.ApplicationVersion]?.version;

    if (!version || !this.conditionValue || !this.versionMatchType) {
      return Ok(false);
    }

    const result = Utilities.compareSemVer({
      version,
      compareVersion: this.conditionValue,
      operator: this.versionMatchType,
    });

    if (!result.ok) {
      return Err(result.error);
    }

    return Ok(result.data);
  }
}
